module.exports = __webpack_public_path__ + "media/images/paradox-master-logo-0ed1f03b.png";